import { boot } from 'quasar/wrappers'
import hasRanking from '../functions/has-score'

export default boot(({ app }) => {
	app.config.globalProperties.$hasScore = hasRanking
})
